import request from "@/utils/request"; // 导入封装的 axios 实例
import API_URLS from "./apiUrls"; // 导入 API 路径配置文件

export const PostLogin = async (params) => {
  return request.post(API_URLS.RESOURCE_LOGIN, params);
};

// 封装获取资源导航数据的函数
export const fetchResourceNavi = async (params) => {
  return request.post(API_URLS.RESOURCE_NAVI, params);
};

// 获取分类下知识库列表的接口
export const PostselectKnowledgeBaseList = async (params) => {
  return request.post(API_URLS.RESOURCE_CONTENT, params);
};

// 获取推荐知识库的接口
export const UpKnowledgeBaseList = async (params) => {
  return request.post(API_URLS.RESOURCE_TUIJIANKNOW, params);
};

// 添加采购清单
export const PostAddCardList = async (params) => {
  return request.post(API_URLS.RESOURCE_INSERUSERCART, params);
};

// 获取购清单
export const PostGetCardList = async (params) => {
  return request.post(API_URLS.RESOURCE_CARTBYUSERID, params);
};

// 删除购清单
export const PostDeleteCardList = async (params) => {
  return request.post(API_URLS.RESOURCE_DELETEUSERID, params);
};

// 修改购清单
export const PostUpdateCardList = async (params) => {
  return request.post(API_URLS.RESOURCE_UPDATEUSERID, params);
};

// 登录认证
export const PostLoginToken = async (params) => {
  return request.post(API_URLS.RESOURCE_UDERTOKEN, params);
};

// 数据库详情
export const PostKonwInfo = async (params) => {
  return request.post(API_URLS.RESOURCE_KNOWINFO, params);
};

// 数据库详情
export const PostUserInfo = async (params) => {
  return request.post(API_URLS.RESOURCE_UDERINFO, params);
};

// 确认订单接口
export const PostOrderList = async (params) => {
  return request.post(API_URLS.RESOURCE_ORDERLIST, params);
};

// 获取用户订单列表
export const PostOrderUserList = async (params) => {
  return request.post(API_URLS.RESOURCE_ORDERbyuserLIST, params);
};

// 获取用户订单列表
export const PostKnowledgeAreaList = async (params) => {
  return request.post(API_URLS.RESOURCE_KNOWLEDGEAREALIST, params);
};

// 批量加入
export const PostUserCarList = async (params) => {
  return request.post(API_URLS.RESOURCE_USERCARLIST, params);
};

// 订单支付页面接口
export const PostOrderByList = async (params) => {
  return request.post(API_URLS.RESOURCE_ORDERBYLIST, params);
};

// 清空订单页面接口
export const PostOrderDeleteList = async (params) => {
  return request.post(API_URLS.RESOURCE_ORDERDELETELIST, params);
};

// /获取地方特色的知识库的接口：
export const PostProvienKnowList = async (params) => {
  return request.post(API_URLS.RESOURCE_PROVINCEKONWLEDGELIST, params);
};
// 获取应用领域对应的知识库的接口

export const PostBusInessKnmwList = async (params) => {
  return request.post(API_URLS.RESOURCE_BUSINESSKNOWLEDGELIST, params);
};

// 知识库榜单
export const PostknowLaDeist = async (params) => {
  return request.post(API_URLS.RESOURCE_KNOWLEDEGEELIST, params);
};


// 知识库页面嵌入前的校验
export const PostkCHECKOAUTH = async (params) => {
  return request.post(API_URLS.RESOURCE_CHECKOAUTH, params);
};

// 地方省份特色
export const PostProvince = async (params) => {
  return request.post(API_URLS.RESOURCE_PROVINCE, params);
};

// //精品数据库
export const PostJPknowList = async (params) => {
  return request.post(API_URLS.RESOURCE_KNOWLEDGE, params);
};


export const getUnitUser = async (params) => {
  return request.post(API_URLS.RESOURCE_GETUNITUSER, params);
};


export const getCheckUser = async (params) => {
  return request.post(API_URLS.RESOURCE_CHECKUSER, params);
};

export const getNewKnowledgeBaseList = async (params) => {
  return request.post(API_URLS.RESOURCE_NEWKNOWLEDELIST, params);
};


export const getBuyKnowledgeBaseList = async (params) => {
  return request.post(API_URLS.RESOURCE_BUYKNOWLEDELIST, params);
};

export const getBuyLog = async (params) => {
  return request.post(API_URLS.RESOURCE_LOG, params);
};

export const getLibraryKnowledgeBaseList = async (params) => {
  return request.post(API_URLS.RESOURCE_LIBRARYKNOWLEDGE, params);
};

export const getselectNotice = async (params) => {
  return request.post(API_URLS.RESOURCE_YWDT, params);
};
export const getselectPartner = async (params) => {
  return request.post(API_URLS.RESOURCE_HZHB, params);
};

export const getselectIndexKnowledgeUp = async (params) => {
  return request.post(API_URLS.selectIndexKnowledgeUp, params);
};

export const getselectIndexKnowledgeDown = async (params) => {
  return request.post(API_URLS.selectIndexKnowledgeDown, params);
};
export const getselectIndexBannerList = async (params) => {
  return request.post(API_URLS.selectIndexBannerList, params);
};






















